module.exports = new __parcel__URL__("BNBLogo.3dada3dc.svg").toString();